module.exports = __webpack_public_path__ + "img/ico-play.37f5ef43.svg";